/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import Logic from 'fierry/data/logic';


export default class SectorCass extends Logic
{
  setCurrentUser (user)
  {
    this.object.set({ currentUser: user });
  }


  setFutureColony (colony)
  {
    this.object.set({ futureColony: colony });
  }


};
